// extracted by mini-css-extract-plugin
export default {"mobileHeaderButton":"MobileHeaderButton_mobileHeaderButton__qpCbg","showText":"MobileHeaderButton_showText__LCtui"};